(function () {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.m-sub-nav a.m-nav[href*="/products/"]').forEach(link => {
      if (link.querySelector('.meteor-menu-desc')) return;

      const handle = link.getAttribute('href')
        .replace('/products/', '')
        .split('?')[0];

      fetch('/products/' + handle + '.js')
        .then(res => res.json())
        .then(product => {
          const desc = document.createElement('div');
          desc.className = 'meteor-menu-desc';
          desc.textContent = product.description
            .replace(/(<([^>]+)>)/gi, '')
            .trim()
            .slice(0, 80);

          link.appendChild(desc);
        })
        .catch(() => {});
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  if (window.__jdgmGlobalModalBound) return;
  window.__jdgmGlobalModalBound = true;
  window.__jdgmUseUnifiedModalHandler = true;

  var activeModal = null;
  var savedScrollY = 0;

  function getGlobalModal() {
    return document.querySelector('[data-judgeme-global-modal]');
  }

  /** Landing / patches / drink: use global drawer (custom-reviews + widget) like product pages */
  function shouldPreferGlobalReviewsModal() {
    if (!document.body) return false;
    var suffix = (document.body.getAttribute('data-page-template-suffix') || '').trim();
    var handle = (document.body.getAttribute('data-page-handle') || '').trim();
    if (suffix === 'landing' || suffix === 'patches' || suffix === 'drink') return true;
    if (handle === 'landing' || handle === 'patches' || handle === 'drink') return true;
    if (typeof document.body.className === 'string') {
      var cls = ' ' + document.body.className + ' ';
      return (
        cls.indexOf(' landing ') !== -1 ||
        cls.indexOf(' patches ') !== -1 ||
        cls.indexOf(' drink ') !== -1
      );
    }
    return false;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function syncCustomReviewsHeader(scope) {
    if (!scope) return;

    var wrappers =
      scope.matches && scope.matches('[data-custom-reviews]')
        ? [scope]
        : scope.querySelectorAll
          ? scope.querySelectorAll('[data-custom-reviews]')
          : [];

    for (var i = 0; i < wrappers.length; i += 1) {
      var root = wrappers[i];
      var countEl = root.querySelector('[data-custom-review-count]');
      var scoreEl = root.querySelector('[data-custom-review-score]');
      var starsSlot = root.querySelector('[data-custom-rating-stars]');
      var widget = root.querySelector('[data-custom-reviews-widget]');
      var badge = root.querySelector('.jdgm-prev-badge');

      var count = 0;
      var average = 0;

      if (badge) {
        count = toNumber(badge.getAttribute('data-number-of-reviews') || badge.getAttribute('data-number_of_reviews'), 0);
        average = toNumber(badge.getAttribute('data-average-rating') || badge.getAttribute('data-average_rating'), 0);
      }

      if ((!count || !average) && widget) {
        var text = widget.textContent || '';
        if (!count) {
          var countMatch = text.match(/([0-9]+)\s+reviews?/i);
          if (countMatch) count = toNumber(countMatch[1], 0);
        }
        if (!average) {
          var avgMatch = text.match(/([0-9]+(?:\.[0-9]+)?)\s*(?:\/\s*5|out of 5)/i);
          if (avgMatch) average = toNumber(avgMatch[1], 0);
        }
      }

      if (countEl) countEl.textContent = String(Math.max(0, Math.round(count)));
      if (scoreEl) scoreEl.textContent = Math.max(0, average).toFixed(1).replace(/\.0$/, '') + '/5';

      if (starsSlot) {
        var widgetBadge = root.querySelector('.custom-reviews__widget .jdgm-prev-badge');
        if (widgetBadge && !starsSlot.contains(widgetBadge)) {
          starsSlot.innerHTML = '';
          starsSlot.appendChild(widgetBadge);
        }
      }
    }
  }

  function initCustomReviews(scope) {
    if (!scope || !scope.querySelectorAll) return;

    var wrappers = scope.querySelectorAll('[data-custom-reviews]');
    for (var i = 0; i < wrappers.length; i += 1) {
      var root = wrappers[i];
      if (root.dataset.customReviewsInited === 'true') continue;
      root.dataset.customReviewsInited = 'true';

      var widget = root.querySelector('[data-custom-reviews-widget]');
      if (!widget || typeof MutationObserver === 'undefined') continue;

      var observer = new MutationObserver(function () {
        syncCustomReviewsHeader(root);
      });

      observer.observe(widget, { childList: true, subtree: true });
    }

    syncCustomReviewsHeader(scope);
  }

  function getBadgeContext(target) {
    if (!(target instanceof Element)) return null;

    var badgeNode = target.closest(
      '.jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-prev-badge__text, .jdgm-widget.jdgm-preview-badge'
    );
    if (!badgeNode) return null;

    var widgetRoot = badgeNode.closest('.jdgm-widget.jdgm-preview-badge');
    if (!widgetRoot && badgeNode.matches('.jdgm-widget.jdgm-preview-badge')) {
      widgetRoot = badgeNode;
    }

    var productId = widgetRoot ? widgetRoot.getAttribute('data-product-id') || widgetRoot.getAttribute('data-id') : null;

    return {
      badgeNode: badgeNode,
      productId: productId
    };
  }

  function getBodyLockClass(modal) {
    if (!modal) return '';
    return modal.hasAttribute('data-judgeme-modal') ? 'jdgm-reviews-modal-open' : 'jdgm-global-modal-open';
  }

  function updateGlobalModalProduct(modal, badgeNode) {
    if (!modal || !modal.hasAttribute('data-judgeme-global-modal') || !badgeNode) return;

    var widgetRoot = badgeNode.closest('.jdgm-widget.jdgm-preview-badge');
    if (!widgetRoot && badgeNode.matches('.jdgm-widget.jdgm-preview-badge')) {
      widgetRoot = badgeNode;
    }

    var productId = widgetRoot ? widgetRoot.getAttribute('data-product-id') || widgetRoot.getAttribute('data-id') : null;
    if (!productId) return;

    var reviewWidget = modal.querySelector('.jdgm-widget.jdgm-review-widget');
    if (!reviewWidget) return;

    reviewWidget.setAttribute('data-id', productId);
    reviewWidget.setAttribute('data-product-id', productId);
  }

  function updateAnyModalProduct(modal, productId) {
    if (!modal || !productId) return;
    modal.setAttribute('data-product-id', productId);

    var reviewWidget = modal.querySelector('.jdgm-widget.jdgm-review-widget');
    if (!reviewWidget) return;
    reviewWidget.setAttribute('data-id', productId);
    reviewWidget.setAttribute('data-product-id', productId);
  }

  function dispatchJudgeMeLoad() {
    try {
      document.dispatchEvent(new Event('judgeme:load'));
    } catch (error) {
      var evt = document.createEvent('Event');
      evt.initEvent('judgeme:load', true, true);
      document.dispatchEvent(evt);
    }
  }

  function initJudgeMeWidgets() {
    if (window.jdgm) {
      if (typeof window.jdgm.initializeWidgets === 'function') {
        window.jdgm.initializeWidgets();
      }
      if (typeof window.jdgm.loadWidget === 'function') {
        window.jdgm.loadWidget();
      }
    }
    dispatchJudgeMeLoad();
    window.requestAnimationFrame(function () {
      syncCustomReviewsHeader(document);
    });
  }

  function lockBodyScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    if (activeModal) {
      var lockClass = getBodyLockClass(activeModal);
      if (lockClass) document.body.classList.add(lockClass);
    }
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.classList.remove('jdgm-global-modal-open');
    document.body.classList.remove('jdgm-reviews-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }

  function openModal(modal) {
    if (!modal || modal.classList.contains('is-open')) return;
    activeModal = modal;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    initCustomReviews(modal);
    window.requestAnimationFrame(function () {
      initJudgeMeWidgets();
      window.setTimeout(function () {
        syncCustomReviewsHeader(modal);
      }, 200);
    });
  }

  function closeModal(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (activeModal === modal) {
      activeModal = null;
    }
    unlockBodyScroll();
  }

  function getModalForBadge(badgeContext) {
    if (!badgeContext || !badgeContext.badgeNode) return null;
    var badgeNode = badgeContext.badgeNode;
    var productId = badgeContext.productId;

    if (shouldPreferGlobalReviewsModal()) {
      var globalOnly = getGlobalModal();
      if (globalOnly) return globalOnly;
    }

    if (productId) {
      var modalByProductId = document.querySelector('[data-judgeme-modal][data-product-id="' + productId + '"]');
      if (modalByProductId) return modalByProductId;
    }

    var localScope = badgeNode.closest('.state-product-content, .shopify-section, .product, [data-product-id]');
    if (localScope) {
      var localModal = localScope.querySelector('[data-judgeme-modal]');
      if (localModal) return localModal;
    }

    var globalModal = getGlobalModal();
    if (!globalModal) return null;

    return globalModal;
  }

  document.addEventListener(
    'click',
    function (event) {
      var closeTarget = event.target instanceof Element ? event.target.closest('[data-judgeme-global-close], [data-judgeme-modal-close]') : null;
      if (closeTarget) {
        closeModal(closeTarget.closest('[data-judgeme-global-modal], [data-judgeme-modal]'));
        return;
      }

      var badgeContext = event.target instanceof Element ? getBadgeContext(event.target) : null;
      if (!badgeContext) return;

      var modal = getModalForBadge(badgeContext);
      if (!modal) return;

      updateAnyModalProduct(modal, badgeContext.productId);
      updateGlobalModalProduct(modal, badgeContext.badgeNode);
      event.preventDefault();
      openModal(modal);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeModal(activeModal);
  });

  document.addEventListener('shopify:section:load', function () {
    initCustomReviews(document);
    initJudgeMeWidgets();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomReviews(document);
      syncCustomReviewsHeader(document);
    });
  } else {
    initCustomReviews(document);
    syncCustomReviewsHeader(document);
  }
})();
